import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from ".././Banner";
import SubNav from ".././SubNav";
import Footer from "../../Footer";

const icon = require("../../../assets/Detasad Cloud/main_icon_highperformance.svg");

const CloudBackupAndRecovery = () => {
    const heading = `CLOUD BACKUP & RECOVERY`;
    const details = `Protect data on cloud using cloud backup Services from DETASAD.`;

    const overview = [
        `Today, data is currency for any enterprise and hence data protection is one of the most important service needed for any business critical, business support workload. DETASAD cloud offering fully covers data protection aspect with multiple industry proven methodologies in order to assure customer data recovery.`,
        `With many use cases as offering, mentioned below, customer can use all or any to achieve their business goals. It could be remote office data protection or production running in cloud as primary workload backup. Customer will get backup monitoring & daily reports.`
    ];

    const advantages = [
        [
            `Managed Backup`,
            `This service allows customer to meet business RPO by integrating application and database consistent backup using agent.`,
            icon
        ],
        [
            `Premium Backup Service`,
            `Agentless backup service to protect a complete virtual machine and allow customer to fully control its backup environment DETASAD proudly presents this service to customers to leverage fast backup and recovery use cases.`,
            icon
        ],
        [
            `Cloud Backup Storage`,
            `DETASAD provide option to use cloud object storage as destination to keep data protected & stored on cloud storage with an unmatched storage availability.`,
            icon
        ],
        [
            `Backup & Archive to Cloud`,
            `DETASAD offers its customer to sync on prem backup to cloud backup storage as long term or offsite backup use case.  Services compatible with Rubrik, Veeam, Veritas, Dell, Commvault.`,
            icon
        ]
    ];

    const functions = [
        [
            `Durable and Reliable`,
            [
                `Multiple level of Protection from backing up locally to disk, digital off-site vaulting to a different DETASAD Data Center, and/or long-term vaulting options to tape media. Data Protect Backup can be deployed to support environments in Managed Hosting, Dedicated Cloud and Colocation.`
            ]
        ],
        [
            `Easy to Revert Unwanted Changes`,
            [
                `The service protects client data from mistakes, disasters and everything in between, helping meet data backup compliance requirements with a simple, secure solution. Data Protect Backup also eliminates the expense of purchasing and managing infrastructure, assists in reducing exposure to outages by providing local disk-based restores, and helps meet industry or business regulations with long-term tape archiving.`
            ]
        ],
        [`Operating System`, [`Windows, RHEL, Linux, Oracle Sparc, IBM AIX, HPUX`]],
        [`Apps & DB`, [`Oracle, DB2, MS SQL, My SQL, PostgreSQL, Sybase, Open File Manager, SAP, Hana, Exchange`]]
    ];

    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} />
            <SubNav overview={overview} advantages={advantages} functions={functions} />
            <Footer />
        </div>
    );
};

export default CloudBackupAndRecovery;
